"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function QualitTBrauchtZeit() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: pullQuoteRef,
    isVisible: pullQuoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: imagePairRef,
    isVisible: imagePairVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: signRef,
    isVisible: signVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="4990" id="qualität-braucht-zeit" className="bg-background text-foreground">
      <div ref={heroRef} className={`relative w-full overflow-hidden transition-all duration-[1400ms] ease-out ${heroVisible ? "opacity-100" : "opacity-0"}`} style={{
      height: "70vh",
      minHeight: "520px"
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/oldenburg_architecture_modern.webp" alt="Moderne Architektur in Oldenburg mit klaren Linien und hochwertigen Materialien" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to bottom, transparent 35%, hsla(0, 0%, 4%, 0.4) 60%, hsla(0, 0%, 4%, 0.92) 100%)"
      }} />

        <div className="absolute inset-0">
          <div className="h-full max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-4 md:gap-6">
            <div className={`col-span-12 md:col-start-2 md:col-span-6 self-end pb-10 md:pb-16 transition-all duration-[1200ms] delay-300 ease-out ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <h2 className="font-default text-foreground leading-[0.95] tracking-tight" style={{
              fontSize: "clamp(2.75rem, 7vw, 6rem)",
              fontWeight: 400
            }}>
                Exzellenz braucht{" "}
                <span className="italic" style={{
                color: "var(--primary)",
                fontWeight: 500
              }}>
                  Zeit
                </span>
              </h2>
            </div>

            <div className={`hidden md:flex md:col-start-9 md:col-span-4 self-end justify-end pb-10 md:pb-16 transition-all duration-[1200ms] delay-500 ease-out ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <p className="font-mono text-xs tracking-[0.2em] uppercase text-foreground/70">
                Philosophie &middot; Orvo Web &middot; Oldenburg
              </p>
            </div>

            <div className={`md:hidden col-span-12 self-end pb-6 transition-all duration-[1200ms] delay-500 ease-out ${heroVisible ? "opacity-100" : "opacity-0"}`}>
              <p className="font-mono text-[0.6875rem] tracking-[0.2em] uppercase text-foreground/70">
                Philosophie &middot; Orvo Web &middot; Oldenburg
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full" style={{
      backgroundColor: "var(--background)",
      color: "var(--foreground)"
    }}>
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-24 md:pt-[160px] pb-24 md:pb-32">
          <div className="max-w-[720px] mx-auto">
            <div ref={quoteRef} className={`transition-all duration-[1100ms] ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <p className="font-serif italic leading-[1.4]" style={{
              fontSize: "clamp(1.375rem, 2.4vw, 1.875rem)",
              color: "var(--foreground)",
              fontWeight: 400
            }}>
                &ldquo;Großartige digitale Erlebnisse entstehen nicht durch Eile, sondern durch präzise Handwerkskunst und tiefes Verständnis.&rdquo;
              </p>
            </div>

            <Separator className="my-12 md:my-16" style={{
            backgroundColor: "var(--border)"
          }} />
          </div>

          <div ref={bodyRef} className={`max-w-[720px] mx-auto transition-all duration-[1000ms] ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default leading-[1.8] mb-8" style={{
            fontSize: "1.125rem",
            color: "var(--muted-foreground)"
          }}>
              <span className="font-serif float-left mr-3 leading-[0.85]" style={{
              fontSize: "5.5rem",
              color: "var(--primary)",
              fontWeight: 500,
              marginTop: "0.35rem"
            }}>
                W
              </span>
              ir bei Orvo Web glauben, dass eine Website mehr ist als nur Code. Sie ist das digitale Gesicht Ihres Unternehmens. In einer Welt, die immer schneller wird, setzen wir bewusst auf Entschleunigung und Qualität. Jedes Projekt, das wir in Oldenburg betreuen, durchläuft einen sorgfältigen Prozess, bei dem wir Ihre Vision in eine technisch perfekte und ästhetisch anspruchsvolle Lösung übersetzen.
            </p>

            <p className="font-default leading-[1.8] mb-8" style={{
            fontSize: "1.125rem",
            color: "var(--muted-foreground)"
          }}>
              Wir hören zu, analysieren und konzipieren. Wir hinterfragen Standards, um für Sie das Beste herauszuholen. Unser Ziel ist es nicht, einfach nur eine Seite online zu bringen, sondern ein Werkzeug zu schaffen, das Ihr Unternehmen nachhaltig wachsen lässt.
            </p>
          </div>

          <div ref={pullQuoteRef} className={`max-w-[860px] mx-auto my-16 md:my-24 transition-all duration-[1100ms] ease-out ${pullQuoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-serif italic text-center leading-[1.25]" style={{
            fontSize: "clamp(1.625rem, 3.5vw, 2.5rem)",
            color: "var(--foreground)",
            fontWeight: 400
          }}>
              &ldquo;Wir bauen keine Websites für heute. Wir entwickeln digitale Identitäten für die{" "}
              <span style={{
              color: "var(--primary)"
            }}>Zukunft.</span>
              &rdquo;
            </p>
          </div>

          <div className="max-w-[720px] mx-auto">
            <p className="font-default leading-[1.8] mb-8" style={{
            fontSize: "1.125rem",
            color: "var(--muted-foreground)"
          }}>
              Unsere Arbeitsweise ist geprägt von hanseatischer Verlässlichkeit und modernem Designanspruch. Wir kombinieren technische Präzision mit einer eleganten Ästhetik, die Vertrauen schafft und Ihre Kunden überzeugt.
            </p>

            <p className="font-default leading-[1.8] mb-8" style={{
            fontSize: "1.125rem",
            color: "var(--muted-foreground)"
          }}>
              Orvo Web steht für Webdesign, das funktioniert. Wir begleiten Sie von der ersten Idee bis zur erfolgreichen Veröffentlichung und darüber hinaus.
            </p>
          </div>

          <div ref={imagePairRef} className={`w-full my-16 md:my-24 transition-all duration-[1200ms] ease-out ${imagePairVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="grid grid-cols-12 gap-4 md:gap-6">
              <div className="col-span-12 md:col-start-2 md:col-span-10">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-6">
                  <div className="md:col-span-3">
                    <div className="relative w-full overflow-hidden" style={{
                    aspectRatio: "4 / 3"
                  }}>
                      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/webdesign_process_workspace.png" alt="Ein professioneller Arbeitsplatz für Webdesign mit Fokus auf Details" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <p className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase mt-3" style={{
                    color: "var(--muted-foreground)"
                  }}>
                      Fig. 01 &mdash; Unser kreativer Prozess
                    </p>
                  </div>
                  <div className="md:col-span-2">
                    <div className="relative w-full overflow-hidden" style={{
                    aspectRatio: "3 / 4"
                  }}>
                      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/digital_strategy_planning.png" alt="Strategische Planung für digitale Projekte" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <p className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase mt-3" style={{
                    color: "var(--muted-foreground)"
                  }}>
                      Fig. 02 &mdash; Strategische Planung
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-[720px] mx-auto">
            <p className="font-default leading-[1.8] mb-8" style={{
            fontSize: "1.125rem",
            color: "var(--muted-foreground)"
          }}>
              Jedes Projekt ist einzigartig. Wir nehmen uns die Zeit, Ihr Unternehmen wirklich zu verstehen, um eine Website zu entwickeln, die nicht nur gut aussieht, sondern Ihre Ziele erreicht.
            </p>

            <p className="font-default leading-[1.8] mb-12" style={{
            fontSize: "1.125rem",
            color: "var(--muted-foreground)"
          }}>
              Lassen Sie uns gemeinsam etwas Außergewöhnliches schaffen.
            </p>

            <div ref={signRef} className={`mt-16 transition-all duration-[1100ms] ease-out ${signVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Separator className="mb-8 w-24" style={{
              backgroundColor: "var(--primary)"
            }} />
              <p className="font-mono text-xs tracking-[0.2em] uppercase mb-6" style={{
              color: "var(--foreground)"
            }}>
                &mdash; Ihr Team von Orvo Web
              </p>
              <p className="font-serif italic" style={{
              fontSize: "2.25rem",
              color: "var(--foreground)",
              fontWeight: 400,
              transform: "rotate(-3deg)",
              display: "inline-block",
              letterSpacing: "-0.01em"
            }}>
                Orvo Web
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}